<template>
  <div class="product-owner-filter flex items-end pb-3 mr-4">
    <label v-if="label" class="vs-input--label mr-2">{{ label }}</label>
    <div class="flex items-center flex-wrap">
      <vs-radio
          v-if="showAllOption"
          v-model="radioValue"
          :vs-name="uniqueGroupName"
          :vs-value="allValue"
          class="mr-3"
      >
        All
      </vs-radio>
      <vs-radio
          v-for="option in normalizedOptions"
          :key="option.id"
          v-model="radioValue"
          :vs-name="uniqueGroupName"
          :vs-value="String(option.id)"
          class="mr-3"
      >
        {{ option.label }}
      </vs-radio>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductOwnerRadioFilter",
  props: {
    value: {
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      default: 'Product Owner',
    },
    showAllOption: {
      type: Boolean,
      default: true,
    },
    groupName: {
      type: String,
      default: 'product-owner-filter',
    },
    allValue: {
      type: String,
      default: '__all__',
    },
  },
  data() {
    return {
      radioValue: this.value == null || this.value === '' ? this.allValue : String(this.value),
      uniqueGroupName: `${this.groupName}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    };
  },
  computed: {
    normalizedOptions() {
      return this.options
        .map((option) => ({
          id: option.id !== undefined && option.id !== null ? option.id : option.Id,
          label: option.DisplayName || option.Name || option.name || option.Type || option.label || option.code || option.Code,
        }))
        .filter((option) => option.id != null);
    },
  },
  watch: {
    value(newValue) {
      const nextRadioValue = this.getRadioValue(newValue);
      if (this.radioValue !== nextRadioValue) {
        this.radioValue = nextRadioValue;
      }
    },
    radioValue(newValue) {
      const expectedValue = newValue === this.allValue ? null : Number(newValue) || newValue;
      if (this.value !== expectedValue) {
        this.$emit('input', expectedValue);
      }
    },
  },
  methods: {
    getRadioValue(value) {
      return value == null || value === '' ? this.allValue : String(value);
    },
  },
};
</script>

<style scoped lang="scss">
.product-owner-filter {
  min-width: 280px;
}
</style>
